// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pathEditor_u_ZU_ {
  align-self: stretch;
}

.contentArea_kYAkE, .contentFooter_yhtyn {
  padding: var( --size-padLarge, 16px );
}

.contentArea_kYAkE {
  border-top: 1px solid var( --color-base100 );
  border-bottom: 1px solid var( --color-base100 );
}

.grid_e5Dka > :nth-child(4) > div > div > :nth-child(2) {
 grid-template-columns: auto minmax(0, 1fr) !important;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-rsrc-management/lib/modelEditors/RsrcEditor.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;CACC,qDAAqD;AACtD","sourcesContent":[".pathEditor {\n  align-self: stretch;\n}\n\n.contentArea, .contentFooter {\n  padding: var( --size-padLarge, 16px );\n}\n\n.contentArea {\n  border-top: 1px solid var( --color-base100 );\n  border-bottom: 1px solid var( --color-base100 );\n}\n\n.grid > :nth-child(4) > div > div > :nth-child(2) {\n grid-template-columns: auto minmax(0, 1fr) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pathEditor": `pathEditor_u_ZU_`,
	"contentArea": `contentArea_kYAkE`,
	"contentFooter": `contentFooter_yhtyn`,
	"grid": `grid_e5Dka`
};
export default ___CSS_LOADER_EXPORT___;
